import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const CardTrainingInfoManagementUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0"
        style={{padding: "10px"}}>
        <Form
          id="CardEmployeeInfoManagementUX-Form-1">
          <FormGroup
            id="CardEmployeeInfoManagementUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-3"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("COURSE_LIST")?"":"none"}}>
              <Button
                color={props.tab==="COURSE_LIST"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-6"
                name="COURSE_LIST"
                onClick={props.onChangeTab}
                size="small">
                {props.languageUX === "en" ? "Course List" : "Course List"}
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-4"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("TRAINING_KPI_SETTING")?"":"none"}}>
              <Button
                color={props.tab==="TRAINING_KPI_SETTING"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-7"
                name="TRAINING_KPI_SETTING"
                onClick={props.onChangeTab}
                size="small">
                {props.languageUX === "en" ? "Training KPI Setting" : "Training KPI Setting"}
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeInfoManagementUX-FormField-5"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("SUMMARY_TRAINING_KPI")?"":"none"}}>
              <Button
                color={props.tab==="SUMMARY_TRAINING_KPI"?"blue":undefined}
                id="CardEmployeeInfoManagementUX-Button-8"
                name="SUMMARY_TRAINING_KPI"
                onClick={props.onChangeTab}
                size="small">
                {props.languageUX === "en" ? "Summary Training KPI" : "Summary Training KPI"}
              </Button>
            </FormField>
            <FormField
              id="CardTrainingInfoManagementUX-FormField-10"
              style={{display: props.filteredTabMenu?.includes("TRAINING_SCHEDULE")?"":"none"}}>
              <Button
                color={props.tab==="TRAINING_SCHEDULE"?"blue":undefined}
                id="CardTrainingInfoManagementUX-Button-11"
                name="TRAINING_SCHEDULE"
                onClick={props.onChangeTab}
                size="small">
                {props.languageUX === "en" ? "Training Schedule" : "Training Schedule"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          className="ui divider"
          id="CardEmployeeInfoManagementUX-div-9"
          style={{margin: "-0.5rem 0 0.75rem"}}>

        </div>
      </div>
    )
}


export default CardTrainingInfoManagementUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Mon Aug 04 2025 15:58:06 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"COURSE_LIST\")?\"\":\"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"TRAINING_KPI_SETTING\")?\"\":\"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"SUMMARY_TRAINING_KPI\")?\"\":\"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Course List",
          "valueEN": "Course List"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"COURSE_LIST\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-6"
        },
        "name": {
          "type": "value",
          "value": "COURSE_LIST"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Training KPI Setting",
          "valueEN": "Training KPI Setting"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"TRAINING_KPI_SETTING\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-7"
        },
        "name": {
          "type": "value",
          "value": "TRAINING_KPI_SETTING"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Summary Training KPI",
          "valueEN": "Summary Training KPI"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"SUMMARY_TRAINING_KPI\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-Button-8"
        },
        "name": {
          "type": "value",
          "value": "SUMMARY_TRAINING_KPI"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInfoManagementUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"-0.5rem 0 0.75rem\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingInfoManagementUX-FormField-10"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"TRAINING_SCHEDULE\")?\"\":\"none\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Training Schedule",
          "valueEN": "Training Schedule"
        },
        "color": {
          "type": "code",
          "value": "props.tab===\"TRAINING_SCHEDULE\"?\"blue\":undefined"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingInfoManagementUX-Button-11"
        },
        "name": {
          "type": "value",
          "value": "TRAINING_SCHEDULE"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 11,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardTrainingInfoManagementUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
